export default __webpack_public_path__ + "static/media/MU.d6949ce1.svg";